
import { defineComponent, onMounted, Ref, ref, watch } from "vue"
 
 
export default defineComponent({
  name: "Button",
    props: {
      variant: String,
      text: String,
    },
    setup(props){

      const type: Ref<string> = ref('')

      

      watch(() => props, () => {
        console.log('caiu no watch');
        
        if(!props.variant){
          type.value = "btn-light-danger bg-white"
        }
        if(props.variant === 'primary'){
          type.value = "btn-light-danger"
        }
        if(props.variant === 'secondary'){
          type.value = "btn-danger"
        }
      }, {deep: true})
    
      onMounted(() => {
        if(!props.variant){
           type.value = "btn-light-danger bg-white"
        }
        if(props.variant === 'primary'){
           type.value = "btn-light-danger"
        }
        if(props.variant === 'secondary'){
           type.value = "btn-danger"
        }

      })
    
      return{
        type,
      }
    }
 })

